import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from '@angular/core';
import { DamageCodeSearchComponent } from '../../components/damage-code/damage-code-search/damage-code-search.component';
import { DamageCodeGridComponent } from '../../components/damage-code/damage-code-grid/damage-code-grid.component';
import { DamageCodeFilterComponent } from '../../components/damage-code/damage-code-filter/damage-code-filter.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterLink, RouterModule } from '@angular/router';

import { DamageCodeFilterForm } from '../../form-model/damage-code-filter.form.model';
import { DamageCodeSearchTextForm } from '../../form-model/damage-code-search-text.form.model';
import { DamageCodeService } from '../../services/damage-code.service';

@Component({
  selector: 'app-damage-code',
  templateUrl: './damage-code.component.html',
  styleUrls: ['./damage-code.component.scss'],
  imports: [
    DamageCodeSearchComponent,
    RouterLink,
    RouterModule,
    DamageCodeGridComponent,
    DamageCodeFilterComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DamageCodeComponent implements OnDestroy {
  filterFormGroup = this.formBuilder.group({
    damageCodeFilterForm: this.formBuilder.group<DamageCodeFilterForm>({} as DamageCodeFilterForm),
    damageCodeSearchTextForm: this.formBuilder.group<DamageCodeSearchTextForm>({} as DamageCodeSearchTextForm),
  });

  isDamageCodesList = true;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly damageCodeService: DamageCodeService,
  ) {}

  ngOnDestroy(): void {
    this.damageCodeService.setDamageCodeFilterFormValue(null);
  }
}
